import { Shape } from '@teko/ds-desktop';
import { Information, PolicyAndService } from '@teko/teko-ecommerce';
import { useProductDetailState } from 'contexts';
import { usePolicies } from 'hooks';
import { t } from 'i18n';
import { ProductProviderInfo } from 'modules/product-detail/shared/ProductProviderInfo';

export const NewPolicies = () => {
  const { product } = useProductDetailState();
  const { salePolicies, otherPolicies } = usePolicies(
    product?.sku || '',
    product?.seller?.id,
  );

  return (
    <>
      {salePolicies?.length || otherPolicies?.length ? (
        <Shape
          backgroundColor="white"
          borderRadius="m"
          className="BOXCARDBODY-RIGHT"
          padding="s16"
          marginTop="s8"
        >
          <ProductProviderInfo />
          <Shape padding="s8">
            {!!salePolicies?.length && (
              <PolicyAndService
                maxPolicyAndService={4}
                title={t('Chính sách bán hàng')}
                information={salePolicies as Information[]}
              />
            )}
            {!!otherPolicies?.length && (
              <PolicyAndService
                title={t('Dịch vụ khác')}
                maxPolicyAndService={4}
                information={otherPolicies as Information[]}
                marginTop="s24"
              />
            )}
          </Shape>
        </Shape>
      ) : null}
    </>
  );
};
